var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.86824314,2.5194255 L15.1450635,13.5038611 C15.4190734,13.9833785 15.2524767,14.5942332 14.7729593,14.8682431 C14.6218616,14.9545847 14.4508473,15 14.2768203,15 L1.72317968,15 C1.17089493,15 0.723179678,14.5522847 0.723179678,14 C0.723179678,13.8259731 0.768594996,13.6549588 0.854936536,13.5038611 L7.13175686,2.5194255 C7.40576683,2.03990805 8.01662149,1.87331133 8.49613894,2.14732129 C8.65117022,2.2359106 8.77965384,2.36439422 8.86824314,2.5194255 Z M7,11 L7,13 L9,13 L9,11 L7,11 Z M7.2610545,10 L8.75502684,10 L9.5,5.5 L6.5,5.5 L7.2610545,10 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.66c671e99aad7042df13836665e1ac39.svg";
export { ForwardRef as ReactComponent };